import { Fragment } from 'react';
import cx from 'classnames';
import { useStore } from '../hooks/store';

import {
  HeroBg
} from '../styles/styles.js';

const TicketsHero = ({ heroBg, section }) => {
  const [state] = useStore();
  const { step, pageTitle, calendarType } = state;

  return (
    <Fragment>
      <div id="billboard">
        <HeroBg className={cx({ 'short': calendarType === 'redemption', 'shrink': calendarType === 'booking' && step > 0 && step < 4, 'expand': step === 3 })} heroBg={heroBg}>
          <svg id="hero-flourish" viewBox="0 0 140 80"><path d="M84.725 38.76h4v-1h-4v1zm10.462 0h19.392v-1H95.186v1zm25.856 0h4v-1h-4v1zm6.112 9.154l5.472 5.47 5.47-5.47-5.47-5.47-5.472 5.47zm-54.802-2.137c-.787-.722-1.49-1.767-2.597-3.7-1.09 1.9-1.787 2.94-2.557 3.66l2.595 2.597 2.558-2.557zm-5.86-.744c.744-.686 1.45-1.777 2.75-4.073a.493.493 0 0 1 .24-.375c.086-.05.18-.06.273-.055a.476.476 0 0 1 .27.055.49.49 0 0 1 .244.375c1.32 2.337 2.03 3.427 2.787 4.112l7.198-7.198-10.46-10.46-10.46 10.46 7.16 7.16zm-54.137 2.88l-5.47-5.47-5.472 5.47 5.47 5.472 5.472-5.47zm113.885.5H82.553c-.04.013-.082.027-.127.027h-.01c-2.93-.057-5.565-.203-8.118-1.426a10.402 10.402 0 0 1-1.144-.624l-3.358 3.358-3.39-3.39c-.35.23-.735.438-1.19.656-2.553 1.223-5.188 1.37-8.118 1.426h-.01c-.045 0-.086-.014-.127-.026H13.27L6.886 54.8 0 47.913l6.885-6.886 6.386 6.386h44.585c.01 0 .017.005.026.005 2.493-.072 4.76-.28 6.903-1.31.34-.162.634-.31.903-.47l-7.765-7.766L69.796 26 81.67 37.874l-7.794 7.793c.255.15.533.29.853.444 2.14 1.03 4.41 1.238 6.9 1.31.01 0 .017-.006.026-.006h44.585l6.387-6.386 6.885 6.886-6.885 6.885-6.386-6.386zM13.676 38.762h4v-1h-4v1zm10.464 0h19.39v-1H24.14v1zm25.854 0h4v-1h-4v1z" fill-rule="evenodd"></path></svg>
          <div className="print_logo"><img src="/wp-content/themes/wbstl/images/logos_for_print.svg" width="383" height="145"/></div>
          <h1>{pageTitle}</h1>
        </HeroBg>
      </div>
    </Fragment>
  );
};

export default TicketsHero;
